import { render, staticRenderFns } from "./my-task.vue?vue&type=template&id=ec9de210&scoped=true"
import script from "./my-task.vue?vue&type=script&lang=js"
export * from "./my-task.vue?vue&type=script&lang=js"
import style0 from "./my-task.vue?vue&type=style&index=0&id=ec9de210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9de210",
  null
  
)

export default component.exports